import { render } from "./Markers.vue?vue&type=template&id=22b53a46"
import script from "./Markers.vue?vue&type=script&lang=js"
export * from "./Markers.vue?vue&type=script&lang=js"

import exportComponent from "/buddy/denhaagfietst-sterfietsroutes/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__